/**
 * Purpose:
 *   Renders menu item text with fade animation.
 */

export interface IMenuItemTextProps {
  text: string;
  className: string;
  style?: React.CSSProperties;
}

export function MenuItemText({ text, className, style }: IMenuItemTextProps) {
  return (
    <span className={className} style={style}>
      {text}
    </span>
  );
}
